import { render, staticRenderFns } from "./AllergiesDetails.vue?vue&type=template&id=64b17116"
import script from "./AllergiesDetails.vue?vue&type=script&lang=js"
export * from "./AllergiesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports